import { httpRequest } from "@services/http";
import { Launch } from "@models/launch.model";
import { LaunchSerializer } from "@models/serializers/launchSerializer";

export class CommandLaunches {
  async run(engagementId: number): Promise<Launch[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/launches/`;
    const response = await httpRequest<any[]>(url, { method: "GET" });
    const serializer = new LaunchSerializer();
    return response.map((item) => serializer.deserialize(item));
  }
}
